module.exports = __webpack_public_path__ + "img/公共服务平台.8a611ea1.png";